import { Injectable } from "@angular/core"

//DO NOT DELETE if empty: will be used for feature flags in next implementations
@Injectable()
export class FeatureFlagsService {}
